module.exports = __webpack_public_path__ + "img/03.164ec65a.png";